import slugify from 'slugify';

export default class AnchorNav {
    constructor(el) {
        this.el = document.querySelector(el);
        this.headings = document.querySelectorAll(".pageContainer h2:not(:empty)");
        this.observeScroll = true;
        this.hasCustomAnchorNav = document.querySelector(".pageContainer__nav") ? document.querySelector(".pageContainer__nav").classList.contains("has-custom-anchorNav") : false;
        this.globalOffset = 150;
        this.init();
    }

    init() {

        if (!this.el || !this.headings.length) return;

        const openBtnClass = "anchorNav__toggler";
        const closeBtnClass = "anchorNav__closeBtn";

        if (!this.hasCustomAnchorNav) {
            this.createAnchors();
        }

        window.addEventListener("click", (e) => {
            if (e.target.classList.contains(openBtnClass)) {
                document.querySelector("html").classList.add("anchorNav--open")
            } else if (e.target.classList.contains(closeBtnClass)) {
                document.querySelector("html").classList.remove("anchorNav--open")
            } else if (e.target.closest(".anchorNav__item a") !== null) {
                this.setCurrent(e);
                this.scrollToSection(e);
            }
        });

        window.addEventListener("scroll", e => {
            this.setCurrent(e);
            this.adjustPositionOnScroll(e);
        });
        window.addEventListener("scrollend", e => this.setCurrent(e));

    }

    createAnchors() {
        const list = this.el.querySelector(".anchorNav__items ul");
        const items = [];

        this.headings.forEach(heading => {

            // add ID to heading if doesn't exist 
            if (!heading.id) {
                heading.id = slugify(heading.textContent, {
                    remove: ".", 
                    lower: true,
                    strict: true
                })
            }

            // populate anchor list
            items.push(`<li class="anchorNav__item">
            <a type="button" href="javascript:void(0)" data-target="${heading.id}"><span>${heading.textContent}</span></a>
            </li>`)

        });    

        list.textContent = "";
        list.insertAdjacentHTML("afterbegin", items.join(""));

        // add current state to first link
        const firstLink = document.querySelector(".anchorNav__items div");
        if (firstLink) firstLink.classList.add("is-current");

    }

    scrollToSection(e) {
        e.preventDefault();
        const dataTarget = e.target.closest("a").dataset.target;
        const heading = document.getElementById(dataTarget);

        const infotrack = document.querySelector(".infotrack");
        const header = document.querySelector(".header");

        function setOffset() {
            let offset = 0;
            const marginOffset = 24;

            const isSmallScreen = window.innerWidth <= 991;
            const hasInfotrack = document.body.classList.contains("infotrack-displayed");
            const scrollTop = window.scrollY;
            const targetTop = heading.offsetTop;

            offset =+ marginOffset;
            
            if (!isSmallScreen) {

                if (targetTop < scrollTop) {
                    offset = offset + header.clientHeight;
                } else {
                    offset = 76 + marginOffset;
                }

            } else {
                const headerHeight = 62;
                const headerWithInfotrackHeight = 110;
                const headerFixedHeight = 48;

                if (targetTop < scrollTop) {
                    offset = marginOffset + (!hasInfotrack ? headerHeight : headerWithInfotrackHeight)
                } else {
                    offset = headerFixedHeight + marginOffset
                }

            }

            return offset;

        }

        setOffset();

        const offset = header.clientHeight + 24;

        window.scrollTo({ top: heading.offsetTop - setOffset(), behavior: "smooth" })
    }

    setCurrent(e) {
        let headings;

        if (!this.hasCustomAnchorNav) {
            headings = [...document.querySelectorAll(".pageContainer__main h2")];
        } else {
            headings = [];
            const links = document.querySelectorAll(".anchorNav__items a");
            links.forEach(link => {
                headings.push(document.querySelector(`.pageContainer__main *[id="${link.dataset.target}"]`));
            });
        }

        let currentHeading = null;
        let link = null;
        let offset = this.globalOffset;

        const getLastHeading = headings.filter(heading => heading.offsetTop <= window.scrollY + offset);
        const cleanCurrentClass = () => {
            const links = [...document.querySelectorAll(".anchorNav__items a")];
            links.forEach(link => link.classList.remove("is-current"))
        }

        if (e.type === "click") {
            this.observeScroll = false;

            if (window.innerWidth <= 767) {
                document.querySelector("html").classList.remove("anchorNav--open")
            }

            link = e.target.closest("a");
            currentHeading = document.querySelector(`.pageContainer__main *[id="${link.dataset.target}"]`);
        }

        if (e.type === "scrollend") {
            this.observeScroll = true;
        }

        if (e.type === "scroll" && this.observeScroll) {
            currentHeading = getLastHeading[getLastHeading.length - 1];
            if (currentHeading !== undefined) {
                link = document.querySelector(`.js-anchorNav a[data-target="${currentHeading.id}"]`);
            }
        }

        if (currentHeading !== undefined && currentHeading !== null) {
            cleanCurrentClass();
            link.classList.add("is-current")
        }

    }

    adjustPositionOnScroll(e) {
        let infotrackHeight, headerHeight, headerContainerHeight, offset;

        const hasHeaderUnpinned = document.querySelector("html").classList.contains("has-header-unpinned");
        const infotrack = document.querySelector(".infotrack");
        const header = document.querySelector(".header");
        const container = document.querySelector(".pageContainer__main");

        infotrack ? infotrackHeight = infotrack.clientHeight : infotrackHeight = 0;
        header ? headerHeight = header.clientHeight : headerHeight = 0;
        headerContainerHeight = window.innerWidth <= 991 ? document.querySelector(".header__container").clientHeight : document.querySelector(".header__nav").clientHeight;

        if (!hasHeaderUnpinned) {
            offset = headerHeight
        } else {
            offset = headerContainerHeight
        }

        if (window.innerWidth >= 768 && window.scrollY >= this.el.offsetTop - offset) {
            this.el.classList.add("is-fixed"); 
            this.el.style.top = offset + "px";
            this.el.style.maxHeight = window.innerHeight - offset - 48 + "px";
        } else {
            this.el.classList.remove("is-fixed");
            this.el.style.top = 0; 
            this.el.style.maxHeight = "none";
        }

    }

}